const welcomeList = ['intro', 'gasStation', 'parkinglots', 'onStreetParking'];

const mainFeaturesList = ['refueling', 'parking', 'on-street-parking'];

const bottomTabList = ['main', 'maps', 'orders', 'coins'];

const ordersList = [
  { key: 'refueling', value: '加油站' },
  { key: 'parking', value: '停車場' },
  { key: 'on_street_parking', value: '路邊停車' },
];

const configData = {
  welcomeList,
  mainFeaturesList,
  bottomTabList,
  ordersList,
};

export default configData;
